var __templateData = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  return "<div class=\"diagnostic-meta\">\n  <div class=\"source-of-dx-data-container\"></div>\n  <div class=\"pooled-values-container\"></div>\n  <div class=\"effect-prevalences-container\">\n    <div class=\"effect-container\"></div>\n    <div class=\"prevalences-container\"></div>\n  </div>\n</div>\n";
  },"useData":true});
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}